import React, { useState, useEffect } from "react";
import VideoCard from "./VideoCard";
import "./rules.css";
import { useContext } from "react";
import { DataContext } from "../Datacontext";

const App = () => {
  const { videos } = useContext(DataContext);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (videos.length > 0) {
      let allThumbnailsLoaded = true;
      Promise.all(
        videos.map((video) => {
          return new Promise((resolve) => {
            if (!video.featured_image.thumbnail) {
              allThumbnailsLoaded = false;
              const img = new Image();
              img.src = video.featured_image.thumbnail;
              img.onload = () => resolve();
              img.onerror = () => resolve();
            } else {
              resolve();
            }
          });
        })
      ).then(() => {
        setIsLoading(false);
      });
    } else {
      setIsLoading(true);
    }
  }, [videos]);

  return (
    <div className="app">
      {isLoading && (
        <div className="video-cards-loading">
          <div className="spinner"></div>
        </div>
      )}
      <div
        className="video-cards-container"
        style={{
          padding: 20,
          opacity: isLoading ? 0.5 : 1,
          transition: "opacity 0.3s",
        }}
      >
        {!isLoading && videos.length > 0 && (
          <>
            {videos.map((video, index) => (
              <VideoCard
                key={index}
                thumbnail={video.featured_image.thumbnail}
                title={video.title}
                onClick={video.onClick}
                vimeoUrl={video.video_url}
                cat={video.categories[0].name}
              />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default App;
